<template>

  <div>

    <b-modal
        id="modal-occurrence-file"
        size="xl"
        scrollable
        @hide="getList"
        :title="'Fotos do apontamento: ' + modalOccurrenceFileCodeLabel"
    >
      <OccurrenceFile
          :occurrence-file-type="OccurrenceFileType.type.BEFORE"
          :only-view="isView()"
          type-image
          :foreign-key="modalOccurrenceFileForeignKey"
      />

      <template #modal-footer>
        <div class="w-100 d-flex justify-content-between">

          <b-button
              variant="outline-secondary"
              @click="$bvModal.hide('modal-occurrence-file')"
          >
            Fechar
          </b-button>

          <b-button
              :to="{ path: '/checklist/occurrence/' + modalOccurrenceFileNumber }"
              variant="outline-primary"
              target="_blank"
          >
            <b-icon-box-arrow-up-right class="mr-2"/>
            Detalhar Apontamento Origem
          </b-button>

        </div>
      </template>

    </b-modal>

    <QuoteOccurrenceDialog
        :command="command"
        :quote-occurrence-id="quoteOccurrenceId"
        :foreign-key="foreignKey"
        :customer-id="customerId"
        :company-id="companyId"
        :primary-key="quoteOccurrenceId"
        :enterprise-id="enterpriseId"
        @onSubmit="getList()"/>

    <QuoteOccurrenceResumeByItemDialog
        :foreign-key="foreignKey"
        :primary-key="form.quoteOccurrenceId"
        :totalOccurrences="totalOccurrences"/>

    <t-form-list :generalErrors="generalErrors" :items="items" :fields="fields" :command="command" :user-auth="userAuth"
                 :status="status"
                 :path="path"
                 :busy="!pageFormIsLoaded" :busy-form="!listFormIsLoaded" :busy-list="!listIsLoaded"
                 primary-key-column="quoteOccurrenceId"
                 :primary-key="form.quoteOccurrenceId"
                 :foreign-key-column="foreignKeyColumn"
                 :foreign-key="foreignKey"
                 sortable
                 disable-footer-length
                 @onChangeOrder="getList"
                 @onSubmit="onSubmit" @onItemRead="openQuoteOccurrenceRead" @onItemDelete="onItemDeleteDefault">


      <template #default>

        <div class="ml-1 mb-3">

          <t-button @click="openQuoteOccurrenceInsert">
            <b-icon-node-plus/>
            {{ t('insert') + ' Item' }}
          </t-button>

          <t-button class="ml-3" @click="openModal('modal-quote-occurrence-resume')">
            <b-icon-list-task/>
            Resumo de Serviços
            <t-help title="Todos os serviços agrupados e que estão aprovados pelo cliente."/>
          </t-button>

        </div>

      </template>


      <template #item(beforeFileId)="{item}">

        <b-link @click="onModalOccurrenceFile(item.occurrenceId,item.occurrenceCodeLabel,item.occurrenceNumber)">


          <img v-if="objValid(item.fileWebThumbnailPriority)" style="max-width: 100%;"
               :src="item.fileWebThumbnailPriority"
               class="align-self-center"/>

          <!--          <div v-else class="bg-light p-3 text-black justify-content-center align-content-center d-flex b-radius-small"><b-icon-camera-fill class="opacity-4" /></div>-->
        </b-link>


      </template>

      <template #item(spotFolder)="{item}">

        <span>{{ item.environment }}</span> <span
          v-if="item.environmentComplement !== ''">{{ item.environmentComplement }}</span><small> - {{
          item.spotFolder
        }}</small>
        <br/>

        <b> {{ item.typeChecklistItem }}</b>
        <br/>

        <b-button
            @click="onModalOccurrenceFile(item.occurrenceId,item.occurrenceCodeLabel,item.occurrenceNumber)"
            size="sm"
            class="mt-2"
            variant="outline-primary">
          <b-icon-images class="mr-2"/>
          Editar Fotos
        </b-button>


        <!--        <b-button
                    :to="{path: '/checklist/occurrence/'+item.occurrenceNumber}"
                    size="sm"
                    class="mt-2"
                    variant="outline-primary" target="_blank">
                  <b-icon-box-arrow-up-right class="mr-2"/>
                  {{ item.occurrenceCodeLabel }}
                </b-button>-->

        <div>
          <b-badge variant="danger" v-if="!item.budgetAccepted">Reprovado</b-badge>
        </div>


      </template>


      <template #item(markupPercentage)="{item}">
        <div class="d-flex justify-content-end"><span>{{ item.markupPercentage | number(2) }}%</span></div>

      </template>

      <template #item(quantity)="{item}">
        <span>{{ item.quantity | number }} {{ item.unit }}</span>
      </template>

      <template #item(typePathologyAutomatically)="{item}">
        <span>{{ item.typePathologyAutomatically }}</span>
        <small v-if="item.description !== ''"><br/>{{ item.description }}</small>
        <small v-if="item.note !== ''"><br/>{{ item.note }}</small>

      </template>

    </t-form-list>

  </div>

</template>

<script>
import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageFormMixin from "@/mixins/page/pageFormMixin"
import pageFormListMixin from "@/mixins/page/pageFormListMixin"
import tFormList from "@/components/template/form/list/t-form-list"
import UnitType from "@/model/types/modules/general/UnitType";
import QuoteOccurrenceDialog from "@/views/modules/business/Quote/QuoteOccurrenceDialog";
import QuoteOccurrenceResumeByItemDialog from "@/views/modules/business/Quote/QuoteOccurrenceResumeByItemDialog";
import OccurrenceFile from "@/views/modules/checklist/OccurrenceFile.vue";
import OccurrenceFileType from "@/model/types/modules/checklist/OccurrenceFileType";

export default {
  mixins: [pageDefaultMixin, pageFormMixin, pageFormListMixin],
  components: {OccurrenceFile, tFormList, QuoteOccurrenceDialog, QuoteOccurrenceResumeByItemDialog},
  name: 'QuoteOccurrence',
  data() {
    return {
      UnitType,
      path: "business/quote-occurrence", //Utilizar somente quando fora do padrão
      foreignKeyColumn: "quoteId", //Utilizar quando usar Tabs com outros componentes
      fields: [
        {keyRead: "quoteOccurrenceId", keyDelete: "quoteOccurrenceId"},
        {key: "beforeFileId", label: "", cols: "1"},
        {key: "spotFolder", label: "Item", cols: "3"},
        {key: "quantity", label: "Qtd.", cols: "1", formatter: "number"},
        {key: "unitPrice", label: "Valor Un.", cols: "2", formatter: "money"},
        {key: "totalPriceSale", label: "Valor Total", cols: "2", formatter: "money"},
        {key: "markupPercentage", label: "Margem", cols: "1", formatter: "number"},
      ],
      form: {},
      error: {//Campos que podem receber retorno de erro do backend
        occurrenceId: "",
      },
      quoteOccurrenceId: 0,
      modalOccurrenceFileForeignKey: null,
      modalOccurrenceFileCodeLabel: '',
      modalOccurrenceFileNumber: null
    }
  },
  props: {
    customerId: {
      type: Number,
      required: false,
      default: 0,
    },
    enterpriseId: {
      type: Number,
      default: 0
    },
    totalOccurrences: {
      type: Number,
      required: false,
      default: 0,
    },
    companyId: {
      type: Number,
      required: false,
      default: 0,
    },
  },
  computed: {
    OccurrenceFileType() {
      return OccurrenceFileType
    },
    onForm() {
      return this.form
    }
  },
  methods: {


    defaultForm() {

      //Preenche somente os campos que foram limpos após o reset
      this.defaultFormList()

      this.form.budgetAccepted = true


    },

    mountedPrepare() {

      this.mountedPrepareFormListDefault()

    },

    async mountedContinued() {

      await this.getList()

    },

    async onSubmit() {

      await this.setSendingFormListDefault(this.form.quoteOccurrenceId)


    },

    mountedList() {

      this.listIsLoaded = true

    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela


    openQuoteOccurrenceInsert() {

      this.form.quoteOccurrenceId = 0
      this.command = 'insert'

      setTimeout(() => {
        this.openDialogForm('modal-quote-occurrence')
      }, 200)

    },
    openQuoteOccurrenceRead(id) {

      this.quoteOccurrenceId = id
      this.command = 'update'


      setTimeout(() => {
        this.openDialogForm('modal-quote-occurrence')
      }, 200)

    },


    onModalOccurrenceFile(occurrenceId, occurrenceCodeLabel, occurrenceNumber) {
      this.modalOccurrenceFileForeignKey = occurrenceId;
      this.modalOccurrenceFileCodeLabel = occurrenceCodeLabel;
      this.modalOccurrenceFileNumber = occurrenceNumber;

      this.$bvModal.show('modal-occurrence-file');
    }

    //--------------------------------------------------------------------------------------
  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedFormList()

    await this.mountedContinued()

  },
}
</script>
